<template>
  <nav v-if="totalPages > 1" class="mt-3">
    <ul class="pagination justify-content-center">
      <li class="page-item" :class="{ disabled: value === 1 }">
        <a class="page-link" href="#" @click.prevent="change(value - 1)"
          >Previous</a
        >
      </li>
      <li
        v-for="page in totalPages"
        :key="page"
        class="page-item"
        :class="{ active: page === value }"
      >
        <a class="page-link" href="#" @click.prevent="change(page)">{{
          page
        }}</a>
      </li>
      <li class="page-item" :class="{ disabled: value === totalPages }">
        <a class="page-link" href="#" @click.prevent="change(value + 1)"
          >Next</a
        >
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "base-pagination",
  props: {
    value: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 20,
    },
  },
  emits: ["input", "update:modelValue"],
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.perPage)
    },
  },
  methods: {
    change(page) {
      if (page < 1 || page > this.totalPages) return
      this.$emit("input", page)
      this.$emit("update:modelValue", page)
    },
  },
}
</script>

<style scoped>
.page-item:first-child .page-link,
.page-item:last-child .page-link {
  width: auto !important;
  height: 36px;
  border-radius: 18px !important;
  padding: 0 14px !important;
}
</style>
